import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

function CustomToggleSwitch({
  initialStatus,
  onToggle,
  label = "Default Label",
  iconSrc,
  queryParamKey = "switch",
  customClass = "",
}) {
  const [status, setStatus] = useState(initialStatus);

  useEffect(() => {
    setStatus(initialStatus);
  }, [initialStatus]);

  const handleToggle = useCallback((e) => {
    e.stopPropagation();
    const newStatus = !status;
    setStatus(newStatus);
    if (onToggle) {
      onToggle(newStatus, e); // Custom onToggle callback
    }
  }, [status, onToggle]);

  return (
    <div className={`ml-3 mr-3 d-flex align-items-center ${customClass}`}>
      <label className="switch">
        <input
          type="checkbox"
          value={status}
          checked={status}
          onChange={handleToggle}
        />
        <div className="slider"></div>
      </label>
      {iconSrc && <img className="ml-1" src={iconSrc} alt="Icon" />}
      <span className="ml-1">{label}</span>
    </div>
  );
}

CustomToggleSwitch.defaultProps = {
  label: "Default Label",
  iconSrc: "",
  queryParamKey: "switch",
  customClass: "",
};

export default CustomToggleSwitch;
